export default function FloatingTextInput({
  label,
  inputProps,
  inputClass,
  labelProps,
  labelClass,
  containerProps,
  containerClass,
  showError,
  error,
}: {
  label: string;
  inputProps?: any;
  inputClass?: string;
  labelProps?: any;
  labelClass?: string;
  containerProps?: any;
  containerClass?: string;
  showError?: boolean;
  error?: string;
}) {
  const isMobile =
    window.innerWidth < 768 ||
    /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);
  return (
    <div>
      <div
        className={`relative z-0 ${isMobile ? "bg-[#4F4E4E] rounded-lg" : "bg-zinc-800" } h-12 ${containerClass}`}
        {...containerProps}
      >
        <input
          id="floating_standard"
          className={`block h-full w-full text-sm bg-transparent ${isMobile ? "rounded-lg" : "border-0 border-b" }  border-gray-300 appearance-none focus:outline-none focus:ring-0 peer text-white px-4 ${inputClass}`}
          placeholder=" "
          {...inputProps}
        />
        <label
          className={`absolute text-sm text-stone-300 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-4 -z-10 origin-[0] peer-focus:left-0 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 pl-4 peer-focus:pt-2 ${labelClass}`}
          {...labelProps}
        >
          {label}
        </label>
      </div>
      {showError && error && (
        <span className="text-red-500 text-xs">{error}</span>
      )}
    </div>
  );
}
